export default "__VITE_ASSET__BCCZSs0H__"